import types from './types';

const setEditedSlug = editedSlug => ({
  type: types.SET_EDITED_SLUG,
  payload: editedSlug,
});

const setIsSaving = isSaving => ({
  type: types.SET_IS_SAVING,
  payload: isSaving,
});

export default {
  setEditedSlug,
  setIsSaving,
};
